import { spawn, execSync, type ChildProcess } from "node:child_process";

export function runSetupCommand(
  cmd: string,
  cwd: string,
  onOutput: (stream: "stdout" | "stderr", data: string) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const child = spawn("sh", ["-c", cmd], {
      cwd,
      stdio: ["ignore", "pipe", "pipe"],
      env: { ...process.env },
    });

    child.stdout.on("data", (chunk: Buffer) => {
      onOutput("stdout", chunk.toString());
    });

    child.stderr.on("data", (chunk: Buffer) => {
      onOutput("stderr", chunk.toString());
    });

    child.on("close", (code) => {
      if (code === 0) {
        resolve();
      } else {
        reject(new Error(`Setup command exited with code ${code}`));
      }
    });

    child.on("error", (err) => {
      reject(err);
    });
  });
}

const AUTH_TOKEN_TIMEOUT_MS = 30_000;

export function runAuthTokenCommand(cmd: string, userEmail: string, cwd: string): string | null {
  try {
    const output = execSync(`${cmd} ${JSON.stringify(userEmail)}`, {
      cwd,
      timeout: AUTH_TOKEN_TIMEOUT_MS,
      stdio: ["ignore", "pipe", "ignore"],
      env: { ...process.env },
    });
    const token = output.toString().trim();
    return token || null;
  } catch {
    return null;
  }
}

export function runStartCommand(
  cmd: string,
  cwd: string,
  onOutput: (stream: "stdout" | "stderr", data: string) => void,
): ChildProcess {
  const child = spawn("sh", ["-c", cmd], {
    cwd,
    stdio: ["ignore", "pipe", "pipe"],
    detached: true,
    env: { ...process.env },
  });

  child.stdout.on("data", (chunk: Buffer) => {
    onOutput("stdout", chunk.toString());
  });

  child.stderr.on("data", (chunk: Buffer) => {
    onOutput("stderr", chunk.toString());
  });

  child.unref();
  return child;
}
